@for (file of courseFiles; track $index) {
<div
  class="d-flex align-items-center justify-content-between border border-dashed border-gray-300 rounded w-100 p-5"
  [ngClass]="{ 'mb-8': $index !== courseFiles.length - 1 }"
>
  <div class="d-flex flex-aligns-center align-items-center pe-8">
    <img alt="" class="w-30px me-3" src="./assets/media/svg/files/pdf.svg" />

    <div class="ms-1 fw-semibold">
      @if (isFileLocked(file)) {
      <span
        class="fs-6 text-gray-500 fw-bold text-overflow-line-2"
        data-testid="file-locked"
        >{{ file.filename }}</span
      >
      } @else {
      <a
        [attr.href]="fileUrl + file.file_url"
        target="_blank"
        class="fs-6 text-gray-700 text-hover-info fw-bold text-overflow-line-2"
        >{{ file.filename }}</a
      >
      }

      <!-- <div class="text-gray-500">1.9mb</div> -->
    </div>
  </div>
  <div class="d-flex align-items-center">
    @if (isFileLocked(file)) {
    <app-keenicon
      name="lock-2"
      class="fs-1 svg svg-icon text-gray-500"
      [attr.title]="'ONLINE_CLASS.TRIAL_LOCKED' | translate"
    ></app-keenicon>
    } @else {
    <a
      [attr.href]="fileUrl + file.file_url"
      target="_blank"
      class="d-flex align-items-center fs-6 text-gray-700 text-hover-info fw-bold mt-1"
    >
      <app-keenicon name="eye" class="fs-1 svg svg-icon"></app-keenicon>
    </a>
    }
  </div>
</div>
}
